export default __webpack_public_path__ + "static/media/G4.6c45077d.mp3";